import React from 'react';
import PropTypes from 'prop-types';
import './col.scss';

function Col({ children, sm, md, lg, xl, smOffset, mdOffset, lgOffset, xlOffset, extra }) {
  const valuesRetrieved = {
    sm: sm ? ` sm-${sm}` : '',
    md: md ? ` md-${md}` : '',
    lg: lg ? ` lg-${lg}` : '',
    xl: xl ? ` xl-${xl}` : '',
    smOffset: smOffset ? ` sm-offset-${smOffset}` : '',
    mdOffset: mdOffset ? ` md-offset-${mdOffset}` : '',
    lgOffset: lgOffset ? ` lg-offset-${lgOffset}` : '',
    xlOffset: xlOffset ? ` xl-offset-${xlOffset}` : '',
    extra: extra ? ` ${extra}` : '',
  };

  return (
    <div
      className={`col${valuesRetrieved.sm}${valuesRetrieved.md}${valuesRetrieved.lg}${valuesRetrieved.xl}${valuesRetrieved.smOffset}${valuesRetrieved.mdOffset}${valuesRetrieved.lgOffset}${valuesRetrieved.xlOffset}${valuesRetrieved.extra}`}
    >
      {children}
    </div>
  );
}

Col.propTypes = {
  children: PropTypes.any,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
  smOffset: PropTypes.number,
  mdOffset: PropTypes.number,
  lgOffset: PropTypes.number,
  xlOffset: PropTypes.number,
  extra: PropTypes.string,
};

export default Col;
